import React from 'react';
import { Edit, SimpleForm, DisabledInput, TextInput, BooleanInput, LongTextInput } from 'react-admin';

export const CouponEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <DisabledInput source="id" label="ID"/>
      <DisabledInput source="campaign" label="Campaign"/>
      <BooleanInput source="expired" />
      <TextInput source="code" label="Coupon code"/>
      <LongTextInput source="description" label="Coupon description"/>
    </SimpleForm>
  </Edit>
);
